import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function InspritionGallery({ gallery = [] }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const mainSettings = {
    asNavFor: nav2,
    ref: slider1,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
  };

  if (!gallery || gallery.length === 0) {
    return <p>No images available</p>;
  }
  return (
    <div className="product-gallery-wrapper">
      <div className="main-slider">
        <Slider {...mainSettings}>
          {gallery.map((item, i) => (
            <div className="main-slide" key={i}>
              <img
                src={item.image_url}
                alt={`slide-${i}`}
                className="img-fluid main-image"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
